<template>
    <div>
        <vs-row v-if="!isLoading">
            <vs-col class="px-0" vs-w="12">
                <ProfileDetailCard />
            </vs-col>
            <vs-col class="bg-white my-2 rounded shadow" vs-w="12">
                <BasicInfoDetailCard />
            </vs-col>
            <vs-col class="bg-white my-2 rounded shadow" vs-w="12">
                <DiversityDetailCard />
            </vs-col>
            <vs-col class="bg-white my-2 rounded shadow" vs-w="12">
                <CurriculumnDetailCard />
            </vs-col>
            <vs-col class="bg-white my-2 rounded shadow" vs-w="12">
                <AddressDetailCard />
            </vs-col>
            <vs-col class="bg-white my-2 rounded shadow" vs-w="12">
                <ExperienceDetailCard />
            </vs-col>
            <vs-col class="bg-white my-2 rounded shadow" vs-w="12">
                <FormationDetailCard />
            </vs-col>
            <vs-col class="bg-white my-2 rounded shadow" vs-w="12">
                <LanguageDetailCard />
            </vs-col>
            <vs-col class="bg-white my-2 rounded shadow" vs-w="12">
                <SkillsDetailCard />
            </vs-col>
            <vs-col class="bg-white my-2 rounded shadow" vs-w="12">
                <PresentationDetailCard />
            </vs-col>                
            <vs-col class="bg-white my-2 rounded shadow" vs-w="12">
                <ProfessionalProfileCard />
            </vs-col>                
        </vs-row>
    </div>
</template>

<script>
import { mapActions } from 'vuex'
import ProfileDetailCard from '../../components/dashboard/profile-detail/ProfileDetailCard.vue';
import BasicInfoDetailCard from '../../components/dashboard/profile-detail/BasicInfoDetailCard.vue';
import DiversityDetailCard from '../../components/dashboard/profile-detail/DiversityDetailCard.vue';
import CurriculumnDetailCard from '../../components/dashboard/profile-detail/CurriculumnDetailCard.vue';
import AddressDetailCard from '../../components/dashboard/profile-detail/AddressDetailCard.vue';
import ExperienceDetailCard from '../../components/dashboard/profile-detail/ExperienceDetailCard.vue';
import FormationDetailCard from '../../components/dashboard/profile-detail/FormationDetailCard.vue';
import LanguageDetailCard from '../../components/dashboard/profile-detail/LanguageDetailCard.vue';
import SkillsDetailCard from '../../components/dashboard/profile-detail/SkillsDetailCard.vue';
import ProfessionalProfileCard from '../../components/dashboard/profile-detail/ProfessionalProfileCard.vue';
import PresentationDetailCard from '../../components/dashboard/profile-detail/PresentationDetailCard.vue';

export default {
    created() {
        this.loadTalentData()

        this.googleAnalytics()
    },

    data() {
        return {
            isLoading: false
        }
    },

    methods: {
        ...mapActions('step', ['parseStepsInformation', 'completeStepsAfterParse', 'shouldActivateRevision']),
        ...mapActions('progress', [
        'calculateBasicProgress',
        'calculateAddressProgress',
        'calculateExperienceProgress',
        'calculateFormationProgress',
        'calculateLanguageProgress',
        'calculateSkillProgress',
        ]),

        async loadTalentData() {
            var LABEL = localStorage.getItem('label');

            if(LABEL === null){
                LABEL = this.$router.history.current.params.company_label;
                await this.$store.dispatch(
                    "company/fetchCompany",
                    LABEL
                );
                this.$store.getters["company/hasCompanyInfo"];
            }

            this.isLoading = true
            this.$vs.loading({
                text: 'Carregando...'
            })

            await this.$http.get(`api/v1/talent/${LABEL}/user/talent`)
                .then(async payload => await this.parseStepsInformation(payload))
                .then(this.calculateBasicProgress)
                .then(this.calculateAddressProgress)
                .then(this.calculateExperienceProgress)
                .then(this.calculateFormationProgress)
                .then(this.calculateLanguageProgress)
                .then(this.calculateSkillProgress)
                .then(this.completeStepsAfterParse)
                .then(this.shouldActivateRevision)
                .then(() => {
                    this.isLoading = false
                    this.$vs.loading.close()
                })
                .catch(() => {
                    this.isLoading = false
                    this.$vs.loading.close()
            })
        },

        googleAnalytics() {
            const {company_label} = this.$router.history.current.params
            this.$ga.page(`${company_label}/profile/detail`)
        },
    },

    components: {
        ProfileDetailCard,
        BasicInfoDetailCard,
        DiversityDetailCard,
        AddressDetailCard,
        ExperienceDetailCard,
        CurriculumnDetailCard,
        FormationDetailCard,
        LanguageDetailCard,
        SkillsDetailCard,
        ProfessionalProfileCard,
        PresentationDetailCard
    }
}
</script>
